import React from 'react'
import { Tag } from 'antd'

/**
 * "TEST" badge, used for BOTH a clinic flagged `istestclinic` and a patient
 * flagged `istestpatient`. The component only ever took an `isTest` boolean,
 * so one badge serves both and they cannot drift in colour or spacing.
 *
 * ⚠️ The two FLAGS are not the same kind of thing, even though the badge is.
 * `istestclinic` guards destructive deletion and is set by a deliberate DB
 * write; `istestpatient` is admin-editable and guards nothing. See
 * data/models/patient.js and docs/DESIGN_TEST_PATIENT_TAG.md.
 *
 * Renders NOTHING when the flag is absent or false, so it can be dropped in
 * beside any clinic name unconditionally.
 *
 * The flag is set deliberately with a direct DB write
 * (docs/database/migrations/set_test_clinic_flag.js) and is what unlocks guard 3
 * of delete_customer_cascade.js. data/models/customer.js is explicit that it
 * must NOT be editable from admin — "an operator guard you can flip from a UI is
 * weaker than one that needs a deliberate write" — so this component is
 * display-only and `istestclinic` is exposed on the GraphQL `Customer` type but
 * deliberately absent from `input NewCustomer`. Showing it here is the visual
 * counterpart to that guard: whoever is looking at the clinic can tell at a
 * glance that its data is disposable.
 *
 * `flexShrink: 0` matters in the header, where this sits in a flex row next to
 * the clinic name — without it the tag is the thing that collapses when space
 * runs short, which is exactly backwards.
 *
 * @param {boolean} isTest  the clinic's `istestclinic` value
 * @param {object}  style   optional extra styles merged over the defaults
 */
const TestClinicTag = ({ isTest, style }) => {
  if (!isTest) return null
  return (
    <Tag
      color='volcano'
      style={{
        marginLeft: 8,
        marginRight: 0,
        flexShrink: 0,
        fontSize: '0.7rem',
        lineHeight: '18px',
        fontWeight: 600,
        letterSpacing: '0.04em',
        ...style,
      }}
    >
      TEST
    </Tag>
  )
}

export default TestClinicTag
